import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/views/remote-vnc/no-vnc/app/images/drag.svg'
import _imports_1 from '@/views/remote-vnc/no-vnc/app/images/keyboard.svg'
import _imports_2 from '@/views/remote-vnc/no-vnc/app/images/toggleextrakeys.svg'
import _imports_3 from '@/views/remote-vnc/no-vnc/app/images/ctrl.svg'
import _imports_4 from '@/views/remote-vnc/no-vnc/app/images/alt.svg'
import _imports_5 from '@/views/remote-vnc/no-vnc/app/images/windows.svg'
import _imports_6 from '@/views/remote-vnc/no-vnc/app/images/tab.svg'
import _imports_7 from '@/views/remote-vnc/no-vnc/app/images/esc.svg'
import _imports_8 from '@/views/remote-vnc/no-vnc/app/images/ctrlaltdel.svg'
import _imports_9 from '@/views/remote-vnc/no-vnc/app/images/power.svg'
import _imports_10 from '@/views/remote-vnc/no-vnc/app/images/clipboard.svg'
import _imports_11 from '@/views/remote-vnc/no-vnc/app/images/fullscreen.svg'
import _imports_12 from '@/views/remote-vnc/no-vnc/app/images/settings.svg'
import _imports_13 from '@/views/remote-vnc/no-vnc/app/images/disconnect.svg'
import _imports_14 from '@/views/remote-vnc/no-vnc/app/images/connect.svg'


const _hoisted_1 = {
  id: "noVNC_fallback_error",
  class: "noVNC_center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "noVNC encountered an error:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { id: "noVNC_fallback_errormsg" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  id: "noVNC_control_bar_anchor",
  class: "noVNC_vcenter"
}
const _hoisted_5 = { id: "noVNC_control_bar" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "noVNC_control_bar_handle",
  title: "Hide/Show the control bar"
}, [
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_7 = { class: "noVNC_scroll" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "noVNC_view_drag_button",
  class: "noVNC_button noVNC_hidden",
  title: "Move/Drag viewport"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { id: "noVNC_mobile_buttons" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    id: "noVNC_keyboard_button",
    class: "noVNC_button",
    title: "Show keyboard"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  id: "noVNC_toggle_extra_keys_button",
  class: "noVNC_button",
  title: "Show extra keys"
}, null, -1)
const _hoisted_11 = { class: "noVNC_vcenter" }
const _hoisted_12 = {
  id: "noVNC_modifiers",
  class: "noVNC_panel"
}
const _hoisted_13 = {
  src: _imports_3,
  id: "noVNC_toggle_ctrl_button",
  class: "noVNC_button",
  title: "Toggle Ctrl"
}
const _hoisted_14 = {
  src: _imports_4,
  id: "noVNC_toggle_alt_button",
  class: "noVNC_button",
  title: "Toggle Alt"
}
const _hoisted_15 = {
  src: _imports_5,
  id: "noVNC_toggle_windows_button",
  class: "noVNC_button",
  title: "Toggle Windows"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  id: "noVNC_send_tab_button",
  class: "noVNC_button",
  title: "Send Tab"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  id: "noVNC_send_esc_button",
  class: "noVNC_button",
  title: "Send Escape"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  id: "noVNC_send_ctrl_alt_del_button",
  class: "noVNC_button",
  title: "Send Ctrl-Alt-Del"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_9 + "\" id=\"noVNC_power_button\" class=\"noVNC_button\" title=\"Shutdown/Reboot...\"><div class=\"noVNC_vcenter\"><div id=\"noVNC_power\" class=\"noVNC_panel\"><div class=\"noVNC_heading\"><img alt=\"\" src=\"" + _imports_9 + "\"> Power </div><input type=\"button\" id=\"noVNC_shutdown_button\" value=\"Shutdown\"><input type=\"button\" id=\"noVNC_reboot_button\" value=\"Reboot\"><input type=\"button\" id=\"noVNC_reset_button\" value=\"Reset\"></div></div>", 2)
const _hoisted_21 = {
  src: _imports_10,
  id: "noVNC_clipboard_button",
  class: "noVNC_button",
  title: "Clipboard"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"noVNC_vcenter\"><div id=\"noVNC_clipboard\" class=\"noVNC_panel\"><div class=\"noVNC_heading\"><img alt=\"\" src=\"" + _imports_10 + "\"> Clipboard </div><p class=\"noVNC_subheading\"> Edit clipboard content in the textarea below. </p><textarea id=\"noVNC_clipboard_text\" rows=\"5\"></textarea></div></div><img src=\"" + _imports_11 + "\" id=\"noVNC_fullscreen_button\" class=\"noVNC_button noVNC_hidden\" title=\"Full screen\"><img src=\"" + _imports_12 + "\" id=\"noVNC_settings_button\" class=\"noVNC_button\" title=\"Settings\">", 3)
const _hoisted_25 = { class: "noVNC_vcenter" }
const _hoisted_26 = {
  id: "noVNC_settings",
  class: "noVNC_panel"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "noVNC_heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: _imports_12
  }),
  /*#__PURE__*/_createTextVNode(" Settings ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "noVNC_setting_shared",
    type: "checkbox",
    class: "toggle"
  }),
  /*#__PURE__*/_createTextVNode(" Shared mode ")
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "noVNC_setting_view_only",
    type: "checkbox",
    class: "toggle"
  }),
  /*#__PURE__*/_createTextVNode(" View only ")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "noVNC_setting_view_clip",
    type: "checkbox",
    class: "toggle"
  }),
  /*#__PURE__*/_createTextVNode(" Clip to window ")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<li><label for=\"noVNC_setting_resize\">Scaling mode:</label><select id=\"noVNC_setting_resize\" name=\"vncResize\"><option value=\"off\">None</option><option value=\"scale\">Local scaling</option><option value=\"remote\">Remote resizing</option></select></li><li><hr></li>", 2)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "noVNC_setting_quality" }, "Quality:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("input", {
  id: "noVNC_setting_quality",
  type: "range",
  min: "0",
  max: "9",
  value: "6"
}, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "noVNC_setting_compression" }, "Compression level:", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("input", {
  id: "noVNC_setting_compression",
  type: "range",
  min: "0",
  max: "9",
  value: "2"
}, null, -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "noVNC_setting_repeaterID" }, "Repeater ID:", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("input", {
  id: "noVNC_setting_repeaterID",
  type: "text",
  value: ""
}, null, -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"noVNC_expander\">WebSocket</div><div><ul><li><label><input id=\"noVNC_setting_encrypt\" type=\"checkbox\" class=\"toggle\"> Encrypt </label></li><li><label for=\"noVNC_setting_host\">Host:</label><input id=\"noVNC_setting_host\"></li><li><label for=\"noVNC_setting_port\">Port:</label><input id=\"noVNC_setting_port\" type=\"number\"></li><li><label for=\"noVNC_setting_path\">Path:</label><input id=\"noVNC_setting_path\" type=\"text\" value=\"websockify\"></li></ul></div>", 2)
const _hoisted_50 = [
  _hoisted_48
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "noVNC_setting_reconnect",
    type: "checkbox",
    class: "toggle"
  }),
  /*#__PURE__*/_createTextVNode(" Automatic reconnect ")
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "noVNC_setting_reconnect_delay" }, "Reconnect delay (ms):", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("input", {
  id: "noVNC_setting_reconnect_delay",
  type: "number"
}, null, -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "noVNC_setting_show_dot",
    type: "checkbox",
    class: "toggle"
  }),
  /*#__PURE__*/_createTextVNode(" Show dot when no cursor ")
], -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Logging: "),
  /*#__PURE__*/_createElementVNode("select", {
    id: "noVNC_setting_logging",
    name: "vncLogging"
  })
], -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  id: "noVNC_disconnect_button",
  class: "noVNC_button",
  title: "Disconnect"
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", {
  id: "noVNC_hint_anchor",
  class: "noVNC_vcenter"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "noVNC_control_bar_hint" })
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { id: "noVNC_status" }, null, -1)
const _hoisted_69 = { class: "noVNC_center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", {
  id: "noVNC_connect_dlg",
  style: {"min-width":"320px"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", { id: "noVNC_connect_button" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        src: _imports_14
      }),
      /*#__PURE__*/_createTextVNode(" Connect ")
    ])
  ])
], -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"noVNC_center noVNC_connect_layer\"><div id=\"noVNC_verify_server_dlg\" class=\"noVNC_panel\"><form><div class=\"noVNC_heading\"> Server identity </div><div> The server has provided the following identifying information: </div><div id=\"noVNC_fingerprint_block\"> Fingerprint: <span id=\"noVNC_fingerprint\"></span></div><div> Please verify that the information is correct and press &quot;Approve&quot;. Otherwise press &quot;Reject&quot;. </div><div class=\"button_row\"><input id=\"noVNC_approve_server_button\" type=\"submit\" value=\"Approve\"><input id=\"noVNC_reject_server_button\" type=\"button\" value=\"Reject\"></div></form></div></div><div class=\"noVNC_center noVNC_connect_layer\"><div id=\"noVNC_credentials_dlg\" class=\"noVNC_panel\"><form><div class=\"noVNC_heading\"> Credentials </div><div id=\"noVNC_username_block\"><label for=\"noVNC_username_input\">Username:</label><input id=\"noVNC_username_input\"></div><div id=\"noVNC_password_block\"><label for=\"noVNC_password_input\">Password:</label><input id=\"noVNC_password_input\" type=\"password\"></div><div class=\"button_row\"><input id=\"noVNC_credentials_button\" type=\"submit\" value=\"Send credentials\"></div></form></div></div><div id=\"noVNC_transition\"><div id=\"noVNC_transition_text\"></div><div><input type=\"button\" id=\"noVNC_cancel_reconnect_button\" value=\"Cancel\"></div><div class=\"noVNC_spinner\"></div></div><div id=\"noVNC_container\"><textarea id=\"noVNC_keyboardinput\" autocapitalize=\"off\" autocomplete=\"off\" spellcheck=\"false\" tabindex=\"-1\"></textarea></div>", 4)

import UI from "@/views/remote-vnc/no-vnc/app/ui.js";
import { onMounted, onUnmounted, ref } from 'vue'
import '@/views/remote-vnc/no-vnc/app/error-handler.js';
import dayjs from 'dayjs'
import { interval } from 'rxjs'
import {
  ConnectStateRes, DEBUG_REMOTE,
  REMOTE_STATE, REMOTE_TYPE, VncDevice
} from '@/views/dashboard/group/client/modals/remote-assist/remote-assist.service'
import { useRoute } from 'vue-router'
import { vncDeviceStore } from '@/services/remote-device.service'

const NON_ESSENTIAL_SWITCH = false;

export default /*#__PURE__*/_defineComponent({
  __name: 'remote-vnc',
  setup(__props) {

const route = useRoute()
/** 是否开启非必要功能 */
const statusTimer = ref(null)
const connectInfo = ref({} as VncDevice)
let response;
let defaults = {};
let mandatory = {};

function updateConnectInfo () {
  connectInfo.value = vncDeviceStore.getDevice(route.query.device_id)
}

function loopDeviceStatus () {
  statusTimer.value = interval(3000).subscribe(() => {
    UI.remoteAssistService.getConnectState({
      device_id: connectInfo.value.device_id,
      remote_type: connectInfo.value.remote_type || REMOTE_TYPE.REMOTE_ASSIST
    }).then((res: ConnectStateRes) => {
      if (res.connect_status === REMOTE_STATE.IDLE && UI.connected) {
        console.log('检测到服务端已断开远控，因此前端主动关闭WS连接')
        UI.disconnect()
      }
    }).catch((error) => {
      const ret = error.responseBody?.ret // 取消http全局错误事件
    })
  })
}

function httpStateErrorBlock (error) {
  const ret = error.responseBody?.ret // 取消http全局错误事件
  const tipsText = '请勿使用他人的远控链接。请关闭此页面后，使用团队管理平台页面操作进行远控'
  if (+localStorage.getItem(DEBUG_REMOTE) === 1) {
    startConnect()
    return
  }

  if (!connectInfo.value?.ws_url) {
    UI.showStatus(`远控信息缺失，${tipsText}。`, 'error');
  } else {
    // 本地已有有效的 ws_url，即使 getConnectState 校验失败也尝试发起连接
    console.warn('getConnectState 校验失败，但本地存在 ws_url，尝试直接连接', error)
    startConnect()
  }
}

function pagehide () {
  console.log('检测到远控窗口卸载(短时间重新访问可重连)，因此前端只主动关闭WS连接')
  // 这里未彻底关闭也断开WS连接，是为了刷新时与后端WS服务更好衔接，避免画面卡顿或重连失败。
  UI.disconnect();
  vncDeviceStore.replaceDevice({ ...connectInfo.value, unload_timestamp: dayjs().valueOf() })
}

function beforeUnload(e: BeforeUnloadEvent) {
  const message = '确定要离开此页面吗？SSH连接将会断开。'
  e.preventDefault()
  e.returnValue = message
  return message
}

function startConnect () {
  loopDeviceStatus()
  UI.start({ settings: { defaults: defaults, mandatory: mandatory } });
  vncDeviceStore.replaceDevice({ ...connectInfo.value, unload_timestamp: undefined })
  UI.remoteAssistService.reportHeartbeat(connectInfo.value.device_id)
  window.addEventListener('beforeunload', beforeUnload);
  window.addEventListener('pagehide', pagehide);
  window.addEventListener('storage', updateConnectInfo);
}

function initPage () {
  UI.remoteAssistService.getConnectState({
    device_id: connectInfo.value.device_id,
    remote_type: connectInfo.value.remote_type || REMOTE_TYPE.REMOTE_ASSIST
  }).then(() => {
    startConnect()
  }).catch(httpStateErrorBlock)
}

updateConnectInfo()
onMounted(() => {
  initPage()
})

onUnmounted(() => {
  statusTimer.value?.unsubscribe();
  window.removeEventListener('beforeunload', beforeUnload);
  window.removeEventListener('pagehide', pagehide);
  window.removeEventListener('storage', updateConnectInfo);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, NON_ESSENTIAL_SWITCH]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                [_vShow, NON_ESSENTIAL_SWITCH]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                [_vShow, NON_ESSENTIAL_SWITCH]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                [_vShow, NON_ESSENTIAL_SWITCH]
              ]),
              _hoisted_16,
              _hoisted_17,
              _hoisted_18
            ])
          ]),
          _hoisted_19,
          _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
            [_vShow, NON_ESSENTIAL_SWITCH]
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("ul", null, [
                _withDirectives(_createElementVNode("li", null, _hoisted_29, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_31, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _hoisted_32,
                _withDirectives(_createElementVNode("li", null, _hoisted_34, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _hoisted_35,
                _withDirectives(_createElementVNode("li", null, _hoisted_39, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_42, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_44, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_47, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_50, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_52, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_54, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_57, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_59, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_61, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_63, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ]),
                _withDirectives(_createElementVNode("li", null, _hoisted_65, 512), [
                  [_vShow, NON_ESSENTIAL_SWITCH]
                ])
              ])
            ])
          ]),
          _hoisted_66
        ])
      ])
    ]),
    _hoisted_67,
    _hoisted_68,
    _withDirectives(_createElementVNode("div", _hoisted_69, _hoisted_71, 512), [
      [_vShow, NON_ESSENTIAL_SWITCH]
    ]),
    _hoisted_72
  ], 64))
}
}

})